import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { resolveImg } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const settings = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welkom terug!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Inloggen mislukt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={resolveImg(settings.logo_url)} alt="Klusbedrijf Pruijn" className="h-28 w-auto object-contain" />
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-[#111111] p-8 md:p-10 border border-white/10">
          <div className="flex items-center gap-3 mb-7">
            <Lock className="text-[#FF1A1A]" size={22} />
            <h1 className="font-heading text-2xl font-bold text-white">Admin login</h1>
          </div>
          <div className="flex flex-col gap-6">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail"
              data-testid="login-email-input"
              className="w-full bg-transparent border-b border-white/20 focus:border-[#FF1A1A] outline-none py-3 text-white transition-colors placeholder:text-white/30"
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Wachtwoord"
              data-testid="login-password-input"
              className="w-full bg-transparent border-b border-white/20 focus:border-[#FF1A1A] outline-none py-3 text-white transition-colors placeholder:text-white/30"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="bg-[#FF1A1A] text-white px-8 py-4 font-semibold hover:bg-[#E60000] transition-colors flex items-center justify-center gap-2 mt-2 disabled:opacity-60"
            >
              {loading ? <><Loader2 size={18} className="animate-spin" /> Inloggen...</> : "Inloggen"}
            </button>
          </div>
        </form>
        <p className="text-center text-white/30 text-xs mt-6">Klusbedrijf Pruijn — beheeromgeving</p>
      </div>
    </div>
  );
}
